<template>
  <div class="portfolio-container">
    <!-- Loading Animation -->
    <div class="loading-screen" v-if="isLoading">
      <div class="loading-content">
        <div class="loading-text">
          <span v-for="(letter, index) in nameLetters" :key="index" 
                :style="{ animationDelay: `${index * 0.1}s` }" 
                class="loading-letter">
            {{ letter }}
          </span>
        </div>
        <div class="loading-bar">
          <div class="loading-progress" :style="{ width: loadingProgress + '%' }"></div>
        </div>
      </div>
    </div>

    <!-- Progress Indicator -->
    <div class="scroll-progress" :style="{ width: scrollProgress + '%' }"></div>

    <!-- Floating Navigation -->
    <nav class="floating-nav" :class="{ 'nav-visible': showNav }">
      <div class="nav-items">
        <a href="#hero" class="nav-item" :class="{ active: activeSection === 'hero' }" @click="scrollToSection('hero')">
          <span class="nav-number">01</span>
          <span class="nav-label">Home</span>
        </a>
        <a href="#projects" class="nav-item" :class="{ active: activeSection === 'projects' }" @click="scrollToSection('projects')">
          <span class="nav-number">02</span>
          <span class="nav-label">Projects</span>
        </a>
        <a href="#development" class="nav-item" :class="{ active: activeSection === 'development' }" @click="scrollToSection('development')">
          <span class="nav-number">03</span>
          <span class="nav-label">Development</span>
        </a>
        <a href="#contact" class="nav-item" :class="{ active: activeSection === 'contact' }" @click="scrollToSection('contact')">
          <span class="nav-number">04</span>
          <span class="nav-label">Contact</span>
        </a>
      </div>
    </nav>

    <!-- Custom Cursor -->
    <div class="custom-cursor" ref="cursor">
      <div class="cursor-inner"></div>
    </div>

    <!-- Hero Background -->
    <div class="hero-background">
      <div class="hero-background-image"></div>
      <div class="hero-background-overlay"></div>
      <div class="particle-container" ref="particles"></div>
    </div>

    <!-- Hero Section -->
    <section class="hero-section" id="hero" ref="hero">
      <div class="hero-content">
        <h1 class="hero-title" ref="heroTitle">SOMENDRA SAINI</h1>
        <h2 class="hero-subtitle" ref="heroSubtitle">Infrastructure | AI | Development</h2>
        <div class="hero-description">
          <p ref="heroDesc1">Full Stack Developer | Masters in Data Science and AI</p>
          <p ref="heroDesc1">Senior Engineer Infrastructure Support for Microsoft</p>
          <p ref="heroDesc2">Building Cool things for all !</p>
        </div>
        <div class="hero-links">
          <a href="#" class="social-link" ref="social1" data-tooltip="GitHub">
            <i class="fab fa-github"></i>
          </a>
          <a href="#" class="social-link" ref="social2" data-tooltip="LinkedIn">
            <i class="fab fa-linkedin"></i>
          </a>
          <a href="#" class="social-link" ref="social3" data-tooltip="Email">
            <i class="fas fa-envelope"></i>
          </a>
        </div>
      </div>
    </section>

    <!-- Projects Title Section -->
    <section class="projects-title-section" id="projects" ref="projectsTitle">
      <div class="projects-title-background"></div>
      <div class="projects-title-content">
        <h2 class="projects-main-title">PROJECTS</h2>
        <p class="projects-subtitle">Explore my latest work and innovations</p>
      </div>
    </section>

    <!-- Projects Section -->
    <section class="project-section" id="isovision" ref="project1">
      <div class="project-background">
        <div class="project-background-image" style="background-image: url('https://images.unsplash.com/photo-1453728013993-6d66e9c9123a?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80');"></div>
        <div class="project-background-overlay"></div>
      </div>
      <div class="project-glass">
        <div class="project-content">
          <div class="project-info">
            <div class="project-number">01</div>
            <h3 class="project-category">AI/Image Processing</h3>
            <h2 class="project-title">IsoVision</h2>
            <p class="project-description">
              Advanced image generation and segmentation platform using Stable Diffusion and other AI models.
              Provides professional-grade tools for creative and analytical image processing.
            </p>
            <div class="project-meta">
              <div class="meta-item">
                <span class="meta-label">Status:</span>
                <span class="meta-value status-live">Live</span>
              </div>
            </div>
            <div class="project-links">
              <a href="https://isovision.somendrasaini.com" target="_blank" class="project-link">
                <span>Live Demo</span>
                <i class="fas fa-arrow-right"></i>
              </a>
            </div>
          </div>
          <div class="project-image">
            <div class="gradient-overlay"></div>
            <img src="https://lh3.googleusercontent.com/pw/AP1GczP2gafWE-PxpcvzFaPhPMYB6FoTDMfsl9MWCSgaN04PsyjkrB8lQt7BtDFvQZF-PKDWN5zYfAnxBHMu7T3EOUPSeXyBfeR1sgz925wcDDoz-h1SFeE5sQOY44h0Jyuh5Rz5F44hu0p_KqMFpauBbf3ugA=w1888-h1534-s-no-gm?authuser=0" alt="IsoVision project" loading="lazy">
          </div>
        </div>
      </div>
    </section>

    <section class="project-section" id="onpremkilla" ref="project2">
      <div class="project-background">
        <div class="project-background-image" style="background-image: url('https://images.unsplash.com/photo-1554232456-8727aae0cfa4?ixlib=rb-4.0.3&auto=format&fit=crop&w=2069&q=80');"></div>
        <div class="project-background-overlay"></div>
      </div>
      <div class="project-glass">
        <div class="project-content">
          <div class="project-info">
            <div class="project-number">02</div>
            <h3 class="project-category">IT & Technology Platform</h3>
            <h2 class="project-title">OnPremkilla.com</h2>
            <p class="project-description">
              A comprehensive platform serving as the ultimate destination for everything IT and Technology.
              From infrastructure solutions to cutting-edge tech insights, tutorials, and community-driven content
              for modern IT professionals and enthusiasts.
            </p>
            <div class="project-meta">
              <div class="meta-item">
                <span class="meta-label">Status:</span>
                <span class="meta-value status-development">In Development</span>
              </div>
            </div>
            <div class="project-links">
              <a href="https://onpremkilla.com" target="_blank" class="project-link">
                <span>Visit Site</span>
                <i class="fas fa-arrow-right"></i>
              </a>
            </div>
          </div>
          <div class="project-image">
            <div class="gradient-overlay"></div>
            <img src="https://lh3.googleusercontent.com/pw/AP1GczP0BLzJx8Szt5S9M9Swi5j4u8rsgIATY2we5TFmRDAgsWndDrLXn2Qqymz-ZaqGW2XQ_Q5__FjrYfp5XwsOft4dvPCoDsXdIJNxr8d8hYWx0DlBqOuetFoq01JkJ_w-JjQx-EugKudCvpfZVi3yWAOTZQ=w1996-h1756-s-no-gm?authuser=0" alt="OnPremkilla.com project" loading="lazy">
          </div>
        </div>
      </div>
    </section>

    <section class="project-section" id="oceanwaves" ref="project3">
      <div class="project-background">
        <div class="project-background-image" style="background-image: url('https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80');"></div>
        <div class="project-background-overlay"></div>
      </div>
      <div class="project-glass">
        <div class="project-content">
          <div class="project-info">
            <div class="project-number">03</div>
            <h3 class="project-category">Music Streaming</h3>
            <h2 class="project-title">OceanWaves</h2>
            <p class="project-description">
              Sophisticated Jellyfin client with custom metadata API and AI-powered trend analysis
              for intelligent music recommendations and playlist generation.
            </p>
            <div class="project-meta">
              <div class="meta-item">
                <span class="meta-label">Status:</span>
                <span class="meta-value status-beta">Beta</span>
              </div>
            </div>
            <div class="project-links">
              <a href="https://github.com/GrandmaGotGuns/Oceanwaves_Public" target="_blank" class="project-link">
                <span>Download from Github</span>
                <i class="fas fa-arrow-right"></i>
              </a>
            </div>
          </div>
          <div class="project-image">
            <div class="gradient-overlay"></div>
            <img src="https://lh3.googleusercontent.com/pw/AP1GczNV66trM576llNt5vdk3kn4ohCKGrjUzAsLuXUtSbNzwcc0JEUqsBfysGyCkiRPsCZdrFshfwLdF915YcPwv3hPP7ltWqMPkRXUgCUJMaNfxMJZkCZo-bcK6RAh8LWukHLdkrd3LsdsNWut1VeowkHQ5Q=w1289-h725-s-no-gm?authuser=0" alt="OceanWaves project" loading="lazy">
          </div>
        </div>
      </div>
    </section>

    <section class="project-section" id="storagebox" ref="project4">
      <div class="project-background">
        <div class="project-background-image" style="background-image: url('https://images.unsplash.com/photo-1544197150-b99a580bb7a8?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80');"></div>
        <div class="project-background-overlay"></div>
      </div>
      <div class="project-glass">
        <div class="project-content">
          <div class="project-info">
            <div class="project-number">04</div>
            <h3 class="project-category">Cloud Storage</h3>
            <h2 class="project-title">Storage Box</h2>
            <p class="project-description">
              Enterprise-grade self-hosted storage solution with high availability,
              cross-box sharing, and support for both LAN and DMZ environments.
              A complete Google Drive alternative with enhanced privacy.
            </p>
            <div class="project-meta">
              <div class="meta-item">
                <span class="meta-label">Status:</span>
                <span class="meta-value status-development">In Development</span>
              </div>
            </div>
            <div class="project-links">
              <a href="https://storageboxdemo.somendrasaini.com" target="_blank" class="project-link">
                <span>Live Demo</span>
                <i class="fas fa-arrow-right"></i>
              </a>
              <a href="https://github.com/GrandmaGotGuns/storagebox" target="_blank" class="project-link">
                <span>Docker Image on Github</span>
                <i class="fas fa-arrow-right"></i>
              </a>
            </div>
          </div>
          <div class="project-image">
            <div class="gradient-overlay"></div>
            <img src="https://lh3.googleusercontent.com/pw/AP1GczMouZTDVFpW-3wHVc6pvg4nr8kgub5KWfEfAmRsB6U2bHxrQfXpGFovjnZdukqhgSl76IWqvi2tz4WQXlVoM8K0ahiuGeREJCPFdTkypZnKwKuLzvXoHKcQFWHN2UmsMncP8qXfgElQktgkInfM6oJfpQ=w949-h725-s-no-gm?authuser=0" alt="Storage Box project" loading="lazy">
          </div>
        </div>
      </div>
    </section>

    <section class="project-section" id="darkpad" ref="project5">
      <div class="project-background">
        <div class="project-background-image" style="background-image: url('https://images.unsplash.com/photo-1517180102446-f3ece451e9d8?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80');"></div>
        <div class="project-background-overlay"></div>
      </div>
      <div class="project-glass">
        <div class="project-content">
          <div class="project-info">
            <div class="project-number">05</div>
            <h3 class="project-category">Productivity Tool</h3>
            <h2 class="project-title">Black Notes</h2>
            <p class="project-description">
              Minimalist, distraction-free online productivity suite with
              seamless cross-device synchronization and markdown support.
              Designed for focus and efficiency.
            </p>
            <div class="project-meta">
              <div class="meta-item">
                <span class="meta-label">Status:</span>
                <span class="meta-value status-beta">Beta</span>
              </div>
            </div>
            <div class="project-links">
              <a href="https://blacknotepad.somendrasaini.com" target="_blank" class="project-link">
                <span>Live Demo</span>
                <i class="fas fa-arrow-right"></i>
              </a>
            </div>
          </div>
          <div class="project-image">
            <div class="gradient-overlay"></div>
            <img src="https://lh3.googleusercontent.com/pw/AP1GczMaW-S5TQSHw-_pDStj3WWcwAWux_hoasWiAe094xtadZSk6AceZsrX_uPO2VOpQkLn-2R_BWv5n-3H0ghnjdcjsnqwCxiKfINNRCmiXmWS2pjswgNgsZCCikAJeFBHGEiW1HURYcOW5BCobaDq7DHe1w=w1328-h655-s-no-gm?authuser=0" alt="DarkPad project" loading="lazy">
          </div>
        </div>
      </div>
    </section>

    <section class="project-section" id="gifinator" ref="project6">
      <div class="project-background">
        <div class="project-background-image" style="background-image: url('https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80');"></div>
        <div class="project-background-overlay"></div>
      </div>
      <div class="project-glass">
        <div class="project-content">
          <div class="project-info">
            <div class="project-number">06</div>
            <h3 class="project-category">Android Utility</h3>
            <h2 class="project-title">Gifinator</h2>
            <p class="project-description">
              Powerful Android application that transforms YouTube videos into
              high-quality, shareable GIFs with customizable settings and
              seamless social media integration.
            </p>
            <div class="project-meta">
              <div class="meta-item">
                <span class="meta-label">Status:</span>
                <span class="meta-value status-live">Live</span>
              </div>
            </div>
            <div class="project-links">
              <a href="https://github.com/GrandmaGotGuns/GIFinator" target="_blank" class="project-link">
                <span>Download from Github</span>
                <i class="fas fa-arrow-right"></i>
              </a>
            </div>
          </div>
          <div class="project-image">
            <div class="gradient-overlay"></div>
            <img src="https://images.unsplash.com/photo-1614680376573-df3480f0c6ff?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="Gifinator project" loading="lazy">
          </div>
        </div>
      </div>
    </section>

    <!-- In Development Title Section -->
    <section class="development-title-section" id="development" ref="developmentTitle">
      <div class="development-title-background"></div>
      <div class="development-title-content">
        <h2 class="development-main-title">IN DEVELOPMENT</h2>
        <p class="development-subtitle">Projects currently under construction</p>
      </div>
    </section>

    <!-- Individual In Development Projects -->
    <section class="project-section" id="concerts" ref="project7">
      <div class="project-background">
        <div class="project-background-image" style="background-image: url('https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80');"></div>
        <div class="project-background-overlay"></div>
      </div>
      <div class="project-glass">
        <div class="project-content">
          <div class="project-info">
            <div class="project-number">07</div>
            <h3 class="project-category">Audio Spatialization</h3>
            <h2 class="project-title">Concerts</h2>
            <p class="project-description">
              Spatial audio utility that simulates concert hall and venue acoustics.
              Uses advanced DSP algorithms to recreate realistic sound environments
              with configurable room sizes, materials, and audience presence.
            </p>
            <div class="project-meta">
              <div class="meta-item">
                <span class="meta-label">Status:</span>
                <span class="meta-value status-development">In Development</span>
              </div>
            </div>
            <div class="project-links">
              <button class="project-link-disabled">
                <span>In Development</span>
                <i class="fas fa-clock"></i>
              </button>
            </div>
          </div>
          <div class="project-image">
            <div class="gradient-overlay"></div>
            <img src="https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="Concerts project" loading="lazy">
          </div>
        </div>
      </div>
    </section>

    <section class="project-section" id="stockpredictor" ref="project8">
      <div class="project-background">
        <div class="project-background-image" style="background-image: url('https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80');"></div>
        <div class="project-background-overlay"></div>
      </div>
      <div class="project-glass">
        <div class="project-content">
          <div class="project-info">
            <div class="project-number">08</div>
            <h3 class="project-category">Financial AI</h3>
            <h2 class="project-title">Stock Predictor</h2>
            <p class="project-description">
              Advanced AI system that analyzes stock market trends, news sentiment,
              and historical data to generate accurate price predictions using
              the yfinance library and machine learning models.
            </p>
            <div class="project-meta">
              <div class="meta-item">
                <span class="meta-label">Status:</span>
                <span class="meta-value status-development">In Development</span>
              </div>
            </div>
            <div class="project-links">
              <button class="project-link-disabled">
                <span>In Development</span>
                <i class="fas fa-clock"></i>
              </button>
            </div>
          </div>
          <div class="project-image">
            <div class="gradient-overlay"></div>
            <img src="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="Stock Predictor project" loading="lazy">
          </div>
        </div>
      </div>
    </section>

    <!-- Contact Section -->
    <section class="contact-section" id="contact" ref="contact">
      <div class="contact-glass">
        <h2 class="contact-title">Let's Build Something Amazing</h2>
        <p class="contact-text">
          Interested in collaboration or want to learn more about my work?
          <br>
          I'm always open to discussing new projects and opportunities.
        </p>
        <div class="contact-buttons">
          <a href="mailto:somendra2406@outlook.com" class="contact-button">
            Get In Touch
            <i class="fas fa-arrow-right"></i>
          </a>
          <a href="https://drive.google.com/file/d/1eeWgqLkXeMONqlY7CNiTLITJ3QY6JS1c/view?usp=sharing" class="contact-button contact-button-secondary">
            Download Resume
            <i class="fas fa-download"></i>
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { TextPlugin } from 'gsap/TextPlugin';

export default {
  name: 'HomePage',
  data() {
    return {
      isLoading: true,
      loadingProgress: 0,
      scrollProgress: 0,
      showNav: false,
      activeSection: 'hero',
      nameLetters: 'SOMENDRA SAINI'.split(''),
      cursorX: 0,
      cursorY: 0,
    }
  },
  mounted() {
    gsap.registerPlugin(ScrollTrigger, TextPlugin);
    this.initLoading();
    this.initScrollProgress();
    this.initNavigation();
    this.initCustomCursor();
    this.initParticles();
  },
  methods: {
    initLoading() {
      // Simulate loading
      const loadingInterval = setInterval(() => {
        this.loadingProgress += Math.random() * 15;
        if (this.loadingProgress >= 100) {
          this.loadingProgress = 100;
          setTimeout(() => {
            this.isLoading = false;
            this.initAnimations();
          }, 500);
          clearInterval(loadingInterval);
        }
      }, 100);
    },

    initScrollProgress() {
      window.addEventListener('scroll', () => {
        const scrollTop = window.pageYOffset;
        const docHeight = document.body.offsetHeight - window.innerHeight;
        this.scrollProgress = (scrollTop / docHeight) * 100;
        
        // Show/hide navigation based on scroll
        this.showNav = scrollTop > 100;
      });
    },

    initNavigation() {
      const sections = ['hero', 'projects', 'development', 'contact'];
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.activeSection = entry.target.id;
          }
        });
      }, { threshold: 0.5 });

      sections.forEach(section => {
        const element = document.getElementById(section);
        if (element) observer.observe(element);
      });
    },

    initCustomCursor() {
      const cursor = this.$refs.cursor;
      
      document.addEventListener('mousemove', (e) => {
        this.cursorX = e.clientX;
        this.cursorY = e.clientY;
        
        gsap.to(cursor, {
          x: this.cursorX,
          y: this.cursorY,
          duration: 0.1
        });
      });

      // Add hover effects for interactive elements
      const interactiveElements = document.querySelectorAll('a, button, .project-glass');
      interactiveElements.forEach(element => {
        element.addEventListener('mouseenter', () => {
          cursor.classList.add('cursor-hover');
        });
        element.addEventListener('mouseleave', () => {
          cursor.classList.remove('cursor-hover');
        });
      });
    },

    initParticles() {
      const particleContainer = this.$refs.particles;
      const particleCount = 50;

      for (let i = 0; i < particleCount; i++) {
        const particle = document.createElement('div');
        particle.className = 'particle';
        particle.style.left = Math.random() * 100 + '%';
        particle.style.top = Math.random() * 100 + '%';
        particle.style.animationDelay = Math.random() * 10 + 's';
        particle.style.animationDuration = (Math.random() * 10 + 10) + 's';
        particleContainer.appendChild(particle);
      }
    },

    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },

    initAnimations() {
      // Hero section animations
      const tl = gsap.timeline();
      
      // Direct title animation without letter splitting
      tl.from(this.$refs.heroTitle, {
        duration: 1.2,
        y: 60,
        opacity: 0,
        ease: "power3.out",
      })
      .from(this.$refs.heroSubtitle, {
        duration: 1,
        y: 40,
        opacity: 0,
        ease: "power3.out",
      }, "-=0.6")
      .from([this.$refs.heroDesc1, this.$refs.heroDesc2], {
        duration: 0.8,
        y: 30,
        opacity: 0,
        stagger: 0.1,
        ease: "power3.out",
      }, "-=0.4")
      .from('.social-link', {
        duration: 0.6,
        y: 20,
        opacity: 0,
        stagger: 0.1,
        ease: "back.out(1.7)",
      }, "-=0.2");

      // Projects title section animation
      gsap.from(this.$refs.projectsTitle, {
        scrollTrigger: {
          trigger: this.$refs.projectsTitle,
          start: "top bottom-=100",
          toggleActions: "play none none none"
        },
        y: 60,
        opacity: 0,
        duration: 0.8,
        ease: "power3.out",
      });

      // Development title section animation
      gsap.from(this.$refs.developmentTitle, {
        scrollTrigger: {
          trigger: this.$refs.developmentTitle,
          start: "top bottom-=100",
          toggleActions: "play none none none"
        },
        y: 60,
        opacity: 0,
        duration: 0.8,
        ease: "power3.out",
      });

      // Project section animations
      const projects = [
        this.$refs.project1, this.$refs.project2, this.$refs.project3,
        this.$refs.project4, this.$refs.project5, this.$refs.project6,
        this.$refs.project7, this.$refs.project8
      ];

      projects.forEach((project) => {
        if (!project) return;
        
        gsap.from(project, {
          scrollTrigger: {
            trigger: project,
            start: "top bottom-=100",
            toggleActions: "play none none none",
          },
          y: 80,
          opacity: 0,
          duration: 0.8,
          ease: "power3.out",
        });

        // Enhanced gradient hover effect
        const gradient = project.querySelector('.gradient-overlay');
        if (gradient) {
          let isHovering = false;
          
          project.addEventListener('mouseenter', () => {
            isHovering = true;
          });
          
          project.addEventListener('mouseleave', () => {
            isHovering = false;
            gsap.to(gradient, {
              '--x': '50%',
              '--y': '50%',
              duration: 0.5,
              ease: "power2.out"
            });
          });
          
          project.addEventListener('mousemove', (e) => {
            if (!isHovering) return;
            
            const rect = gradient.getBoundingClientRect();
            const x = ((e.clientX - rect.left) / rect.width) * 100;
            const y = ((e.clientY - rect.top) / rect.height) * 100;
            
            gsap.to(gradient, {
              '--x': `${x}%`,
              '--y': `${y}%`,
              duration: 0.3,
              ease: "power2.out"
            });
          }, { passive: true });
        }
      });

      // Contact section animation
      gsap.from(this.$refs.contact, {
        scrollTrigger: {
          trigger: this.$refs.contact,
          start: "top bottom-=100",
          toggleActions: "play none none none"
        },
        y: 60,
        opacity: 0,
        duration: 0.8,
        ease: "power3.out",
      });
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Bai+Jamjuree:wght@300;400;500;600;700&family=Bebas+Neue&family=Product+Sans:wght@300;400;500;700&display=swap');
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css');

:root {
  --black: #0a0a0a;
  --dark: #121212;
  --darker: #080808;
  --light: #f8f8f8;
  --accent: #3a86ff;
  --accent-dark: #2a76e6;
  --glass: rgba(255, 255, 255, 0.05);
  --glass-border: rgba(255, 255, 255, 0.1);
  --glass-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  --gray: #6c757d;
  --gray-light: #adb5bd;
  --success: #28a745;
  --warning: #ffc107;
  --danger: #dc3545;
  --x: 50%;
  --y: 50%;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-snap-type: y proximity;
  scroll-behavior: smooth;
  overflow-x: hidden;
}

body {
  background-color: var(--black);
  color: var(--light);
  font-family: 'Product Sans', sans-serif;
  overflow-x: hidden;
  line-height: 1.6;
  cursor: none;
}

.portfolio-container {
  max-width: 100vw;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
}

/* Loading Screen */
.loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--black);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  transition: opacity 0.5s ease;
}

.loading-content {
  text-align: center;
}

.loading-text {
  font-family: 'Bebas Neue', sans-serif;
  font-size: 3rem;
  letter-spacing: 0.1em;
  margin-bottom: 2rem;
}

.loading-letter {
  display: inline-block;
  opacity: 0;
  animation: letterPop 0.6s ease forwards;
}

@keyframes letterPop {
  0% {
    opacity: 0;
    transform: translateY(20px) scale(0.8);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.loading-bar {
  width: 300px;
  height: 2px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 1px;
  overflow: hidden;
}

.loading-progress {
  height: 100%;
  background: linear-gradient(90deg, var(--accent), var(--accent-dark));
  transition: width 0.3s ease;
}

/* Scroll Progress */
.scroll-progress {
  position: fixed;
  top: 0;
  left: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--accent), var(--accent-dark));
  z-index: 1000;
  transition: width 0.1s ease;
}

/* Floating Navigation */
.floating-nav {
  position: fixed;
  right: 2rem;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.floating-nav.nav-visible {
  opacity: 1;
  visibility: visible;
}

.nav-items {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.8rem 1.2rem;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 50px;
  color: var(--light);
  text-decoration: none;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  font-weight: 500;
}

.nav-item:hover,
.nav-item.active {
  background: rgba(58, 134, 255, 0.15);
  border-color: rgba(58, 134, 255, 0.3);
  color: var(--accent);
}

.nav-number {
  font-family: 'Bebas Neue', sans-serif;
  font-size: 1.1rem;
  min-width: 20px;
}

.nav-label {
  white-space: nowrap;
}

/* Custom Cursor */
.custom-cursor {
  position: fixed;
  width: 20px;
  height: 20px;
  pointer-events: none;
  z-index: 9999;
  mix-blend-mode: difference;
}

.cursor-inner {
  width: 100%;
  height: 100%;
  background: var(--light);
  border-radius: 50%;
  transition: transform 0.2s ease;
}

.custom-cursor.cursor-hover .cursor-inner {
  transform: scale(2);
  background: var(--accent);
}

/* Particles */
.particle-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.particle {
  position: absolute;
  width: 2px;
  height: 2px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  animation: float infinite ease-in-out;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
    opacity: 0.3;
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
    opacity: 1;
  }
}

/* Project Numbers - Keep for visual hierarchy */
.project-number {
  position: absolute;
  top: 2rem;
  right: 2rem;
  font-family: 'Bebas Neue', sans-serif;
  font-size: 4rem;
  color: rgba(255, 255, 255, 0.05);
  z-index: 1;
}

/* Tooltips */
[data-tooltip] {
  position: relative;
}

[data-tooltip]:hover::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: 120%;
  left: 50%;
  transform: translateX(-50%);
  background: var(--black);
  color: var(--light);
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 0.8rem;
  white-space: nowrap;
  border: 1px solid rgba(255, 255, 255, 0.1);
  z-index: 1000;
}

/* Left-aligned Hero Section */
.hero-section {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 10%;
  position: relative;
  z-index: 1;
}

.hero-content {
  max-width: 800px;
  z-index: 2;
  text-align: left;
}

.hero-title {
  font-family: 'Bebas Neue', sans-serif;
  font-size: 5.5rem;
  letter-spacing: 0.08em;
  line-height: 0.95;
  margin-bottom: 1.5rem;
  background: linear-gradient(135deg, #ffffff 0%, #c0c0c0 50%, #ffffff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.hero-subtitle {
  font-family: 'Bai Jamjuree', sans-serif;
  font-size: 1.8rem;
  font-weight: 500;
  color: var(--accent);
  margin-bottom: 2rem;
  text-shadow: 0 2px 8px rgba(58, 134, 255, 0.3);
  letter-spacing: 0.02em;
}

.hero-description {
  font-size: 1.2rem;
  line-height: 1.7;
  margin-bottom: 3rem;
  opacity: 0.9;
  max-width: 600px;
  font-weight: 300;
}

.hero-links {
  display: flex;
  gap: 3rem;
  justify-content: flex-start;
}

.social-link {
  color: var(--light);
  font-size: 1.8rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform: translateZ(0);
  will-change: transform;
  position: relative;
}

.social-link::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 60px;
  height: 60px;
  background: radial-gradient(circle, rgba(58, 134, 255, 0.1), transparent);
  border-radius: 50%;
  transform: translate(-50%, -50%) scale(0);
  transition: transform 0.3s ease;
  z-index: -1;
}

.social-link:hover {
  color: var(--accent);
  transform: translateY(-4px) scale(1.15);
}

.social-link:hover::before {
  transform: translate(-50%, -50%) scale(1);
}

section {
  scroll-snap-align: start;
  height: 100vh;
  width: 100vw;
  position: relative;
  overflow: hidden;
}

/* Hero Background */
.hero-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: -1;
}

.hero-background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-4.0.3&auto=format&fit=crop&w=2072&q=80');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}

.hero-background-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
}

/* Projects Title Section */
.projects-title-section {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
}

.projects-title-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('https://images.unsplash.com/photo-1553877522-43269d4ea984?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2074&q=80');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  z-index: -2;
}

.projects-title-background::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  z-index: -1;
}

.projects-title-content {
  text-align: center;
  z-index: 2;
  padding: 0 2rem;
}

.projects-main-title {
  font-family: 'Bebas Neue', sans-serif;
  font-size: 6rem;
  letter-spacing: 0.12em;
  line-height: 1;
  margin-bottom: 1.5rem;
  background: linear-gradient(135deg, #ffffff 0%, #c0c0c0 50%, #ffffff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
}

.projects-subtitle {
  font-family: 'Bai Jamjuree', sans-serif;
  font-size: 1.4rem;
  font-weight: 400;
  color: var(--light);
  opacity: 0.9;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
}

/* Development Title Section */
.development-title-section {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
}

.development-title-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('https://images.unsplash.com/photo-1504639725590-34d0984388bd?ixlib=rb-4.0.3&auto=format&fit=crop&w=2074&q=80');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  z-index: -2;
}

.development-title-background::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: -1;
}

.development-title-content {
  text-align: center;
  z-index: 2;
  padding: 0 2rem;
}

.development-main-title {
  font-family: 'Bebas Neue', sans-serif;
  font-size: 6rem;
  letter-spacing: 0.12em;
  line-height: 1;
  margin-bottom: 1.5rem;
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 50%, #ff6b6b 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
}

.development-subtitle {
  font-family: 'Bai Jamjuree', sans-serif;
  font-size: 1.4rem;
  font-weight: 400;
  color: var(--light);
  opacity: 0.9;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
}

/* Project Background */
.project-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -2;
}

.project-background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}

.project-background-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
}

/* Left-aligned Project Sections */
.project-section {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 10%;
  position: relative;
}

.project-glass {
  backdrop-filter: blur(30px) saturate(180%);
  -webkit-backdrop-filter: blur(30px) saturate(180%);
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.08) 0%,
    rgba(255, 255, 255, 0.03) 100%
  );
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  width: 100%;
  height: 85%;
  padding: 3rem;
  box-shadow: 
    0 8px 32px rgba(0, 0, 0, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  will-change: transform;
}

.project-glass::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(
    circle at var(--x, 50%) var(--y, 50%),
    rgba(58, 134, 255, 0.06) 0%,
    transparent 40%
  );
  transition: all 0.4s ease;
  pointer-events: none;
  will-change: background;
}

.project-glass:hover {
  transform: translateY(-6px);
  backdrop-filter: blur(35px) saturate(200%);
  -webkit-backdrop-filter: blur(35px) saturate(200%);
  box-shadow: 
    0 20px 60px rgba(0, 0, 0, 0.4),
    0 0 0 1px rgba(58, 134, 255, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.15);
}

.project-glass:hover::before {
  background: radial-gradient(
    circle at var(--x, 50%) var(--y, 50%),
    rgba(58, 134, 255, 0.12) 0%,
    transparent 50%
  );
}

.project-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  gap: 3rem;
  position: relative;
  z-index: 2;
}

.project-info {
  flex: 1;
  max-width: 550px;
}

.project-category {
  font-family: 'Bai Jamjuree', sans-serif;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--accent);
  margin-bottom: 1.2rem;
  text-transform: uppercase;
  letter-spacing: 0.12em;
}

.project-title {
  font-family: 'Bebas Neue', sans-serif;
  font-size: 3.2rem;
  letter-spacing: 0.04em;
  line-height: 1.1;
  margin-bottom: 1.8rem;
  background: linear-gradient(135deg, #ffffff 0%, #c0c0c0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.project-description {
  font-size: 1.05rem;
  line-height: 1.7;
  margin-bottom: 2.5rem;
  opacity: 0.92;
  color: #e0e0e0;
  font-weight: 300;
}

/* Project Meta Information */
.project-meta {
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: rgba(255, 255, 255, 0.02);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.meta-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.8rem;
  font-size: 0.9rem;
}

.meta-item:last-child {
  margin-bottom: 0;
}

.meta-label {
  font-weight: 600;
  color: var(--gray-light);
}

.meta-value {
  color: var(--light);
  font-weight: 500;
}

.status-live {
  color: var(--success);
  font-weight: 600;
}

.status-beta {
  color: var(--warning);
  font-weight: 600;
}

.status-development {
  color: var(--danger);
  font-weight: 600;
}

.project-links {
  display: flex;
  gap: 1.5rem;
}

.project-link {
  display: inline-flex;
  align-items: center;
  gap: 0.7rem;
  padding: 0.8rem 1.5rem;
  background: linear-gradient(
    135deg,
    rgba(58, 134, 255, 0.15) 0%,
    rgba(58, 134, 255, 0.08) 100%
  );
  color: var(--accent);
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.95rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(58, 134, 255, 0.3);
  overflow: hidden;
  position: relative;
  will-change: transform;
}

.project-link::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: all 0.6s ease;
}

.project-link:hover {
  background: linear-gradient(
    135deg,
    rgba(58, 134, 255, 0.25) 0%,
    rgba(58, 134, 255, 0.15) 100%
  );
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(58, 134, 255, 0.2);
  border-color: rgba(58, 134, 255, 0.5);
}

.project-link:hover::before {
  left: 100%;
}

/* Disabled Project Link */
.project-link-disabled {
  display: inline-flex;
  align-items: center;
  gap: 0.7rem;
  padding: 0.8rem 1.5rem;
  background: linear-gradient(
    135deg,
    rgba(108, 117, 125, 0.15) 0%,
    rgba(108, 117, 125, 0.08) 100%
  );
  color: var(--gray);
  border-radius: 50px;
  font-weight: 600;
  font-size: 0.95rem;
  border: 1px solid rgba(108, 117, 125, 0.3);
  cursor: not-allowed;
  opacity: 0.6;
}

.project-image {
  flex: 1;
  height: 100%;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.35);
  transform: perspective(1000px) rotateY(6deg);
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  will-change: transform;
}

.gradient-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(
    circle at var(--x, 50%) var(--y, 50%),
    rgba(58, 134, 255, 0.2) 0%,
    transparent 60%
  );
  z-index: 1;
  pointer-events: none;
  transition: all 0.4s ease;
  will-change: background;
  mix-blend-mode: overlay;
}

.project-image:hover {
  transform: perspective(1000px) rotateY(0deg) scale(1.03);
  box-shadow: 0 25px 70px rgba(58, 134, 255, 0.15);
}

.project-image:hover .gradient-overlay {
  background: radial-gradient(
    circle at var(--x, 50%) var(--y, 50%),
    rgba(58, 134, 255, 0.3) 0%,
    transparent 70%
  );
}

.project-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
  will-change: transform;
}

.project-image:hover img {
  transform: scale(1.08);
}

/* Contact Section */
.contact-section {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8%;
  background: linear-gradient(135deg, var(--dark) 0%, var(--black) 100%);
  position: relative;
}

.contact-glass {
  backdrop-filter: blur(30px) saturate(180%);
  -webkit-backdrop-filter: blur(30px) saturate(180%);
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.08) 0%,
    rgba(255, 255, 255, 0.03) 100%
  );
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 20px;
  width: 100%;
  height: 70%;
  padding: 3rem;
  box-shadow: 
    0 8px 32px rgba(0, 0, 0, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  will-change: transform;
}

.contact-glass::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(
    circle at var(--x, 50%) var(--y, 50%),
    rgba(58, 134, 255, 0.06) 0%,
    transparent 40%
  );
  transition: all 0.4s ease;
  pointer-events: none;
  will-change: background;
}

.contact-glass:hover {
  transform: translateY(-6px);
  backdrop-filter: blur(35px) saturate(200%);
  -webkit-backdrop-filter: blur(35px) saturate(200%);
  box-shadow: 
    0 20px 60px rgba(0, 0, 0, 0.4),
    0 0 0 1px rgba(58, 134, 255, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.15);
}

.contact-title {
  font-family: 'Bebas Neue', sans-serif;
  font-size: 3.5rem;
  letter-spacing: 0.04em;
  line-height: 1.1;
  margin-bottom: 2rem;
  background: linear-gradient(135deg, #ffffff 0%, #c0c0c0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.contact-text {
  font-size: 1.15rem;
  line-height: 1.7;
  margin-bottom: 3rem;
  opacity: 0.9;
  max-width: 650px;
  color: #e0e0e0;
  font-weight: 300;
}

.contact-buttons {
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
  justify-content: center;
}

.contact-button {
  display: inline-flex;
  align-items: center;
  gap: 0.8rem;
  padding: 1.2rem 2.5rem;
  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-dark) 100%);
  color: var(--light);
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1.1rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  z-index: 1;
  will-change: transform;
  box-shadow: 0 4px 15px rgba(58, 134, 255, 0.3);
}

.contact-button-secondary {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.contact-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  transition: all 0.6s ease;
  z-index: -1;
}

.contact-button:hover {
  transform: translateY(-4px) scale(1.05);
  box-shadow: 0 12px 30px rgba(58, 134, 255, 0.4);
}

.contact-button-secondary:hover {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.08) 100%);
  box-shadow: 0 12px 30px rgba(255, 255, 255, 0.1);
}

.contact-button:hover::before {
  left: 100%;
}

/* Enhanced Responsive Design */
@media (max-width: 1200px) {
  .hero-section, .project-section, .contact-section {
    padding: 0 5%;
  }
  
  .hero-title {
    font-size: 4.5rem;
  }
  
  .projects-main-title, .development-main-title {
    font-size: 5rem;
  }
  
  .project-title {
    font-size: 2.8rem;
  }
  
  .floating-nav {
    right: 1rem;
  }
}

@media (max-width: 1024px) {
  .hero-title {
    font-size: 4rem;
  }
  
  .projects-main-title, .development-main-title {
    font-size: 4.5rem;
  }
  
  .project-content {
    flex-direction: column;
    gap: 2.5rem;
  }
  
  .project-info {
    max-width: 100%;
    text-align: center;
  }
  
  .project-image {
    width: 100%;
    max-width: 500px;
    height: 280px;
    transform: perspective(800px) rotateX(5deg);
    margin: 0 auto;
  }
  
  .project-image:hover {
    transform: perspective(800px) rotateX(0deg) scale(1.02);
  }
  
  .project-glass {
    height: auto;
    min-height: 85vh;
    padding: 2.5rem;
  }
  
  .floating-nav {
    display: none;
  }
  
  .hero-section {
    justify-content: center;
    text-align: center;
  }
}

@media (max-width: 768px) {
  body {
    cursor: auto;
  }
  
  .custom-cursor {
    display: none;
  }
  
  .hero-section {
    padding: 3rem 1.5rem;
    text-align: center;
    justify-content: center;
  }
  
  .hero-title {
    font-size: 3.5rem;
  }
  
  .hero-subtitle {
    font-size: 1.5rem;
  }
  
  .projects-main-title, .development-main-title {
    font-size: 3.5rem;
  }
  
  .projects-subtitle, .development-subtitle {
    font-size: 1.2rem;
  }
  
  .hero-links {
    gap: 2.5rem;
    justify-content: center;
  }
  
  .project-section, .contact-section {
    padding: 0 1.5rem;
    height: auto;
    min-height: 100vh;
    justify-content: center;
  }
  
  .project-glass, .contact-glass {
    margin: 2rem 0;
    padding: 2rem;
  }
  
  .project-title, .contact-title {
    font-size: 2.5rem;
  }
  
  .project-links, .contact-buttons {
    flex-direction: column;
    gap: 1rem;
    align-items: center;
  }
  
  .project-link, .project-link-disabled, .contact-button {
    width: 200px;
    justify-content: center;
  }
  
  .project-number {
    font-size: 2rem;
    top: 1rem;
    right: 1rem;
  }
}

@media (max-width: 480px) {
  html {
    scroll-snap-type: none;
  }
  
  .hero-title {
    font-size: 2.8rem;
  }
  
  .hero-subtitle {
    font-size: 1.2rem;
  }
  
  .projects-main-title, .development-main-title {
    font-size: 2.8rem;
  }
  
  .projects-subtitle, .development-subtitle {
    font-size: 1rem;
  }
  
  .project-title, .contact-title {
    font-size: 2rem;
  }
  
  .project-glass, .contact-glass {
    padding: 1.5rem;
  }
  
  .contact-button {
    padding: 1rem 2rem;
    font-size: 1rem;
  }
  
  .loading-text {
    font-size: 2rem;
  }
  
  .loading-bar {
    width: 200px;
  }
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: var(--black);
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, var(--accent), var(--accent-dark));
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, var(--accent-dark), #1f5fbf);
}

/* Performance optimizations */
.project-image,
.project-glass,
.contact-glass {
  contain: layout style paint;
}

/* SEO and Accessibility improvements */
img {
  alt: attr(alt);
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
